<script>
    import { createEventDispatcher } from 'svelte';
    import { Button } from 'sveltestrap';
    export let logo;
    export let text;
    export let value;
    let expand=false;
    const dispatch = createEventDispatcher();

    function click(){
        dispatch('click',{value:value})        
    }
</script>
<button outline color="dark" on:mouseenter={()=>{expand=true}} on:mouseleave={()=>{expand=false} } 
    on:click={()=>click()}
    style="float:left;padding:2px;margin:0px;margin-left:3px;border-radius: 2px 2px 2px 2px;border-style:solid; border-weight:1px;box-shadow: 0px 0px 2px grey;"
>
    <img on:mouseenter={()=>{expand=true}} src={logo} alt={text} style="width:33px;height:33px;margin:1px;"/>
    {#if expand}
        {text}
    {/if}
</button>